import { render, staticRenderFns } from "./vc-tab.vue?vue&type=template&id=63866120&scoped=true&"
import script from "./vc-tab.vue?vue&type=script&lang=js&"
export * from "./vc-tab.vue?vue&type=script&lang=js&"
import style0 from "./vc-tab.vue?vue&type=style&index=0&id=63866120&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63866120",
  null
  
)

export default component.exports